<div class="d-flex position-absolute h-100 w-100 request-access-area">
  <div class="display-large">
    <div class="login-container h-100">
      <a href="#">
        <img src="./assets/img/logo.webp" class="logo" />
      </a>
      @if (!emailVerificationSubmitted) {
        <form
          class="d-flex flex-column justify-content-center mt-4"
          [formGroup]="emailVerificationForm"
          (ngSubmit)="onEmailVerificationSubmit()"
        >
          <div>
            <h1>{{ 'request-access.email-verification' | translate }}</h1>
            <p>{{ 'request-access.email-verification-text' | translate }}</p>
            <div class="mb-3">
              <label for="email" class="form-label">{{ 'user.email' | translate }}</label>
              <input
                id="email"
                class="form-control"
                type="email"
                formControlName="email"
                placeholder=""
                tabindex="1"
                />
              <div class="form-text">{{ 'request-access.enter-email' | translate }}</div>
              <div class="invalid-feedback">
                @if (emailVerificationForm.controls.email.errors?.['required']) {
                  <div>
                    {{ 'error.required' | translate }}
                  </div>
                }
                @if (emailVerificationForm.controls.email.errors?.['email']) {
                  <div>
                    {{ 'error.email' | translate }}
                  </div>
                }
              </div>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="acceptTerms" formControlName="acceptTerms" tabindex="2"/>
              <label class="form-check-label" for="acceptTerms">{{ 'request-access.accept-terms' | translate }}</label>
            </div>

            <app-error [error]="error"></app-error>
            <button
              type="submit"
              class="btn btn-primary w-100 mt-4 mb-2"
              [class.disabled]="!emailVerificationForm.valid"
              [ladda]="isLoading"
              tabindex="3"
              >
              {{ 'request-access.verify-email' | translate }}
            </button>
            <p>
              <span>{{ 'request-access.already-account' | translate }}</span>
              <a href="/">{{ 'login.login' | translate }}</a>
              <span>{{ 'request-access.continue' | translate }}</span>
            </p>
          </div>
        </form>
      }
      @else if (emailVerificationSubmitted && !isSubmitted) {
        <form
          class="d-flex flex-column justify-content-center mt-4"
          [formGroup]="requestAccessForm"
          (ngSubmit)="onSubmit()"
        >
        <div>
          <h1>{{ 'request-access.signup' | translate }}</h1>
          <p>{{ 'request-access.create-account' | translate }}</p>
          <div class="mb-3">
            <label for="organization" class="form-label">{{ 'request-access.company-name' | translate }}</label>
            <input
              id="organization"
              class="form-control"
              type="text"
              formControlName="organization"
              placeholder="Company name"
              tabindex="1"
              />
            <div class="form-text">
              {{ 'request-access.enter-company-name' | translate }}
            </div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.organization.errors?.['required']) {
                <div>
                  {{ 'error.required' | translate }}
                </div>
              }
            </div>
          </div>
          <div class="mb-3">
            <label for="firstName" class="form-label">{{ 'user.given_name' | translate }}</label>
            <input
              id="firstName"
              class="form-control"
              type="text"
              formControlName="firstName"
              placeholder="First name"
              tabindex="3"
              />
            <div class="form-text">
              {{ 'request-access.enter-firstName' | translate }}
            </div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.firstName.errors?.['required']) {
                <div>
                  {{ 'error.required' | translate }}
                </div>
              }
            </div>
          </div>
          <div class="mb-3">
            <label for="lastName" class="form-label">{{ 'user.family_name' | translate }}</label>
            <input
              id="lastName"
              class="form-control"
              type="text"
              formControlName="lastName"
              placeholder="Last name"
              tabindex="4"
              />
            <div class="form-text">
              {{ 'request-access.enter-lastName' | translate }}
            </div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.lastName.errors?.['required']) {
                <div>
                  {{ 'error.required' | translate }}
                </div>
              }
            </div>
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">{{ 'user.email' | translate }}</label>
            <input
              id="email"
              class="form-control"
              type="email"
              formControlName="email"
              placeholder="name@example.com"
              tabindex="5"
              />
            <div class="form-text">{{ 'request-access.enter-email' | translate }}</div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.email.errors?.['required']) {
                <div>
                  {{ 'error.required' | translate }}
                </div>
              }
              @if (requestAccessForm.controls.email.errors?.['email']) {
                <div>
                  {{ 'error.email' | translate }}
                </div>
              }
            </div>
          </div>
          <div class="mb-3">
            <label for="verificationCode" class="form-label">{{ 'request-access.verification-code' | translate }}</label>
            <input
              id="verificationCode"
              class="form-control"
              type="text"
              formControlName="verificationCode"
              placeholder="Verification code"
              tabindex="6"
              />
            <div class="form-text">
              {{ 'request-access.enter-verification-code' | translate }}
            </div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.verificationCode.errors?.['required']) {
                <div>
                  {{ 'error.required' | translate }}
                </div>
              }
              @if (requestAccessForm.controls.verificationCode.errors?.['pattern']) {
                <div>
                  {{ 'error.pattern' | translate }}
                </div>
              }
            </div>
          </div>

          <div class="mb-3 form-check">
            <input class="form-check-input" type="checkbox" id="acceptTerms" formControlName="acceptTerms"/>
            <label class="form-check-label" for="acceptTerms">{{ 'request-access.accept-terms' | translate }}</label>
          </div>

          <app-error [error]="error"></app-error>
          <button
            type="submit"
            class="btn btn-primary w-100 mt-4 mb-2"
            [class.disabled]="!requestAccessForm.valid"
            [ladda]="isLoading"
            tabindex="7"
            >
            {{ 'request-access.create' | translate }}
          </button>
          <p>
            <span>{{ 'request-access.already-account' | translate }}</span>
            <a href="/">{{ 'login.login' | translate }}</a>
            <span>{{ 'request-access.continue' | translate }}</span>
          </p>
        </div>
      </form>
      } @else if (emailVerificationSubmitted && isSubmitted) {
        <div class="mt-5 text-center mb-5">
          <span class="material-icons text-success icon-xl d-block mb-3">check_circle</span>
          <h1 class="mb-3 fw-bold">
            <span>{{ 'request-access.thanks' | translate }}</span> {{ this.requestAccessForm.controls.firstName.value }}!
          </h1>
          <p class="mb-2">{{ 'request-access.thanks-subtext' | translate }}</p>
          <p class="mb-3">{{ 'request-access.thanks-subtext2' | translate }}</p>
          <p class="mb-2 text-muted">
            <span>{{ 'request-access.thanks-subtext3' | translate }}</span>
            <a href="mailto:{{ this.requestAccessForm.controls.email.value }}">
              {{ this.requestAccessForm.controls.email.value }}
            </a>
            ({{ this.requestAccessForm.controls.organization.value }})
          </p>
          <p class="mb-4 text-muted">
            <span>{{ 'request-access.thanks-subtext4' | translate }}</span>
            <a href="mailto:support&#64;nimmsta.com">support&#64;nimmsta.com</a>.
          </p>
          <a class="btn btn-primary" href="https://nimmsta.com">{{ 'request-access.visit-website' | translate }}</a>
        </div>
      }
      <div class="fw-light d-flex gap-1 bottom-0 justify-content-end" style="right: 0.2rem; color: gray; font-size: 0.6em;">
        <a [href]="'imprint.url' | translate" target="_blank">{{ 'imprint.label' | translate }}</a>
        <span>◦</span>
        <a [href]="'privacy.url' | translate" target="_blank">{{ 'privacy.label' | translate }}</a>
        <span>◦</span>
        <a [href]="'terms.url' | translate" target="_blank">{{ 'terms.label' | translate }}</a>
      </div>
    </div>
  </div>
  <div class="w-50 d-none d-md-block">
    <app-product-placement></app-product-placement>
  </div>
</div>
